module.exports = __webpack_public_path__ + "img/pic_location_HualienCounty.39b4ceba.png";